<template>
  <article class="hcard" :class="[`hcard--${card.art}`, { 'hcard--off': off, 'hcard--small': small, 'hcard--ready': ready, 'hcard--liked': liked }]">
    <!--
      No cost corner any more (playtest 14): a card is bought once and
      played free, so the only number a face carries is what it gives.
    -->
    <span class="hcard__name">{{ card.name }}</span>
    <!-- eslint-disable-next-line vue/no-v-html -- constant art from cardArt.js, never user input -->
    <svg class="hcard__art" viewBox="0 0 48 48" aria-hidden="true" v-html="art" />

    <!-- and what you get is always along the bottom -->
    <span class="hcard__gain">
      <Pip v-for="p in gainPips" :key="p.kind" :kind="p.kind" :n="p.n" signed />
    </span>
    <span v-if="extras.length" class="hcard__extras">{{ extras.join(' · ') }}</span>
    <span v-if="count > 1" class="hcard__count">×{{ count }}</span>
  </article>
</template>

<script>
import { artFor } from './cardArt';
import { SPENDABLE } from './resourceArt';
import Pip from './Pip.vue';

// One card face, wherever a card is shown: fanned in the hand, on the shelf
// of cards to buy, in the deck list. The button around it decides what a tap
// does; this only decides what a card looks like.
//
// A card face ALWAYS shows what the card does when you play it, even on the
// shelf. What it costs to take one is on the shelf's own price tag, never on
// the card. Matt, looking at Tithe - price 1 coin, play cost 2 coin, +2
// happiness: "It looks like it costs me one coin and gets me two happiness.
// But then underneath, it says 'then 2 coin to play'. I don't understand what
// that means." It meant two different transactions drawn as one.
//
// There are no KINDS on a card any more (playtest 14, Elizabeth: "I don't
// know that having the various types of cards is worthwhile"). A grievance
// still looks dark and a law blue, because those two are worth seeing from
// across the hand; everything else is one parchment face.
const ORDER = [...SPENDABLE, 'population', 'happiness', 'threat'];
const sortPips = (obj = {}, keep) => ORDER
  .filter((k) => keep(obj[k]))
  .map((k) => ({ kind: k, n: obj[k] }));

export default {
  name: 'HallCard',
  components: { Pip },
  props: {
    // { id, name, art, gain, extras, price } - see hallFaces.js
    card: { type: Object, required: true },
    // A seated counselor likes this card: a small mark, so the hand says
    // where a card wants to go before it is picked up.
    liked: { type: Boolean, default: false },
    // The shelf's cards are smaller than the ones in your hand, so it is
    // clear at a glance which ones you can actually play right now.
    small: { type: Boolean, default: false },
    off: { type: Boolean, default: false },
    // You can act on this one right now. The gold edge means that and only
    // that, anywhere on the screen.
    ready: { type: Boolean, default: false },
    count: { type: Number, default: 1 },
  },
  computed: {
    art() { return artFor(this.card.id, this.card.art); },
    gainPips() { return sortPips(this.card.gain || {}, (n) => n); },
    extras() { return this.card.extras || []; },
  },
};
</script>
